import api, { adminApiPrefix } from './Api';
import {
  ProductOptionsResponse,
  productOptionsResponseFromResponse,
} from '../interfaces/ProductOption/ProductOptionsResponse';
import { ProductOptionKey } from '../interfaces/ProductOption/ProductOptionKey';
import {
  ProductOption,
  productOptionToUpsertRequest,
} from '../interfaces/ProductOption/ProductOption';
import { MediaOptions } from '../interfaces/MediaOptions';

const productOptionAdminApiPrefix = `${adminApiPrefix}/product-options`;

export const getProductOptions = async (
  productID: number,
): Promise<ProductOptionsResponse> => {
  const response = await api.get(`${productOptionAdminApiPrefix}/${productID}`);

  return productOptionsResponseFromResponse(response.data?.data);
};

export const updateProductOptions = async (
  productID: number,
  keys: ProductOptionKey[],
  options: ProductOption[],
): Promise<ProductOptionsResponse> => {
  const response = await api.put(
    `${productOptionAdminApiPrefix}/${productID}`,
    {
      option_keys: keys.map((key, i) => ({
        name: key.key,
        name_translation: key.nameTranslation,
        position: i,
      })),
      option_values: options.map((option) =>
        productOptionToUpsertRequest(option),
      ),
    },
  );

  return productOptionsResponseFromResponse(response.data?.data);
};

export const updateProductOptionMedia = async (
  productID: number,
  position: number,
  media: MediaOptions,
): Promise<void> => {
  const bodyFormData = new FormData();

  bodyFormData.append('position', position.toString());

  if (media.image) {
    bodyFormData.append('image', media.image);
  }

  if (media.eraseImage) {
    bodyFormData.append('erase', '1');
  }

  return api.put(
    `${productOptionAdminApiPrefix}/media/${productID}`,
    bodyFormData,
  );
};
